import {
  ChakraProvider,
  theme as baseTheme,
  extendTheme,
  withDefaultColorScheme,
} from '@chakra-ui/react';
import '@fontsource/source-sans-pro/400.css';
import '@fontsource/source-sans-pro/600.css';
import 'focus-visible/dist/focus-visible';
import { useRouter } from 'next/router';
import * as React from 'react';

import { theme } from '@/imports/ui/chakra/theme';
import { createColorScale } from '@/imports/ui/chakra/utilities/create-color-scale';
import { createColorScaleGray } from '@/imports/ui/chakra/utilities/create-color-scale-gray';
import { createColorScaleSecondary } from '@/imports/ui/chakra/utilities/create-color-scale-secondary';

type IDynamicThemeProvider = {
  children: React.ReactNode;
  primaryColor: string | null | undefined;
};

// brand colors
const tradewingPurple = '#1676ce';
const tradewingShakti = '#F44941';

// theme colors
const fallbackSecondary = '#1676ce'; 
const gray= '#718096';
const success = '#2C8530';
const error = '#DC3545';
const textPrimary = '#121212';
const textSecondary = '#333333';
const bgPrimary = 'rgba(245, 245, 245, 0.40)'; //with 40% opacity
const bgSecondary = 'rgba(245, 245, 245, 1)';
const strokePrimary = '#D4D4D4';
const shadowBase = "0 1px 2px 0 rgba(0, 0, 0, 0.09)";

export const DynamicThemeProvider: React.FC<IDynamicThemeProvider> = (
  props
) => {
  const router = useRouter();

  const primaryColor = router.asPath.startsWith('/admin')
    ? tradewingPurple
    : props.primaryColor;

  const brandedChakraTheme = extendTheme(
    {
      ...theme,
      colors: {
        primary: primaryColor
          ? createColorScale(primaryColor)
          : baseTheme.colors.blue,
        purple: createColorScale(tradewingPurple),
        Shakti: createColorScale(tradewingShakti),
        secondary: primaryColor
          ? createColorScaleSecondary(primaryColor)
          : createColorScaleSecondary(fallbackSecondary),
        gray: createColorScaleGray(gray), //718096 old gray color
        success: createColorScale(success),
        error: createColorScale(error),
        textPrimary: createColorScale(textPrimary),
        textSecondary: createColorScale(textSecondary),
        bgPrimary: createColorScale(bgPrimary),
        bgSecondary: createColorScale(bgSecondary),
        strokePrimary:createColorScale(strokePrimary),
      },
      shadows: {
        base: shadowBase,
      },
    },
    withDefaultColorScheme({ colorScheme: 'primary' })
  );

  return (
    <ChakraProvider theme={brandedChakraTheme}>{props.children}</ChakraProvider>
  );
};
